/* oxlint-disable */

typeof window !== 'undefined' && typeof globalThis !== 'object' && (window.globalThis = window);

/**
 * Available in:
 * Edge: 120
 * Firefox: 115
 * Chrome: 120
 * Safari: 17.0
 *
 * https://caniuse.com/mdn-api_url_canparse_static
 */
// Modified from https://github.com/zloirock/core-js/blob/master/packages/core-js/modules/web.url.can-parse.js
if (!('canParse' in URL)) {
  URL.canParse = function (url, base) {
    try {
      return !!new URL(url, base);
    } catch {
      return false;
    }
  };
}

/**
 * Available in:
 * Edge: 100
 * Firefox: 97
 * Chrome: 100
 * Safari: 15.4
 *
 * https://caniuse.com/mdn-api_abortsignal_throwifaborted
 */
if (!('throwIfAborted' in AbortSignal.prototype)) {
  AbortSignal.prototype.throwIfAborted = function () {
    if (!this.aborted) return;
    throw this.reason;
  };
}
